export const TRANSACTION_TYPES = {
  CLUB_DEAL: "CLUB_DEAL",
  PRIVATE_FINANCING: "PRIVATE_FINANCING",
  CROWDFUNDING: "CROWDFUNDING",
  VENDOR_LOAN: "VENDOR_LOAN",
  CARRYING: "CARRYING",
  REDEMPTION_SALE: "REDEMPTION_SALE",
  PENDING: "PENDING",
};

export const TRANSACTION_TYPES_LABELS = {
  [TRANSACTION_TYPES.CLUB_DEAL]: "Club-deal",
  [TRANSACTION_TYPES.PRIVATE_FINANCING]: "Financement Privé",
  [TRANSACTION_TYPES.CROWDFUNDING]: "Crowdfunding",
  [TRANSACTION_TYPES.VENDOR_LOAN]: "Crédit Vendeur",
  [TRANSACTION_TYPES.CARRYING]: "Portage Immobilier",
  [TRANSACTION_TYPES.REDEMPTION_SALE]: "Vente à Réméré",
  [TRANSACTION_TYPES.PENDING]: "Intermédiation / Autre",
};
